<div class="row no-padding  justify-content-center">
    <div class="col-10 side-nav-content">
      <div class="row justify-content-center">

        <div class="col-12 margin-block-s">
          <a href="https://subscribe.clem.mobi/inform" >
  
            <button class="col-12" mat-stroked-button color="" (click)="CloseAction();"style="text-align: left;height: 50px;font-size: 17px; border-color: #3a539b;">
                <img height="25px;" style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Utilisateur.svg"/>
                {{ 'MENU.DECONNECTE.BOUTON1' | translate }}</button>
          </a>
        </div>

        <div class="col-12 margin-block-s">
          <a href="https://subscribe.clem.mobi/" >
  
            <button class="col-12" mat-stroked-button color="" (click)="CloseAction();"style="text-align: left;height: 50px;font-size: 17px; border-color: #3a539b;">
                <img height="25px;" style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Utilisateur.svg"/>
                {{ 'MENU.DECONNECTE.BOUTON2' | translate }}</button>
          </a>
        </div>

        <div class="col-12 margin-block-s">
          <a routerLink="/connexion" routerLinkActive="active">
            <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Deconnexion.svg"/>
                {{ 'MENU.DECONNECTE.BOUTON3' | translate }}</button>
          </a>
        </div>
        <div class="col-12 margin-block-s">
          <a [routerLink] = "['/']"  fragment="ccm">
            <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px; border-color: #3a539b;">
                <img height="25px;" style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_Aide.svg"/>
                {{ 'MENU.DECONNECTE.BOUTON4' | translate }}</button>
          </a>
        </div>

        
        <div class="col-12 margin-block-s">
          <a routerLink="/faq" routerLinkActive="active">
            <button class="col-12" mat-stroked-button color="" (click)="CloseAction();" style="text-align: left;height: 50px;font-size: 17px;     border-color: #3a539b;">
                <img height="25px;"  style="vertical-align: middle;" src="../../../assets/img/Pictos_Appli/Bleu/SVG/Picto_FAQ.svg"/>
                {{ 'MENU.DECONNECTE.BOUTON5' | translate }}</button>
          </a>
        </div>
  
      </div>
  
    </div>
  
  </div>
  